// We're getting a bunch of html from the server and shoving it into react here.

import * as React from 'react';

import {Api, formEncodedApi} from 'nutshell-core/api';

import 'less/support.less';

type Props = {
    viewUrl: string;
    viewParams: string;
};

type State = {
    serverMarkup: string | null | undefined;
    didRenderServerMarkup: boolean;
};

const viewApi = new Api('/');
const headers = new Headers({
    'Content-Type': 'application/xhtml+xml',
    accept: '*/*',
    'X-Requested-With': 'XMLHttpRequest',
});

export class SupportDashboardPage extends React.Component<Props, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            serverMarkup: null,
            didRenderServerMarkup: false,
        };
    }

    componentDidMount() {
        this.fetchNewMarkup();
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (
            prevProps.viewUrl !== this.props.viewUrl ||
            prevProps.viewParams !== this.props.viewParams
        ) {
            this.fetchNewMarkup();
        }

        if (
            prevState.serverMarkup !== this.state.serverMarkup ||
            prevState.didRenderServerMarkup !== this.state.didRenderServerMarkup
        ) {
            if (this.state.didRenderServerMarkup) {
                Nut.updateAppearances();
                Nut.preparePage();
                setUpEvents();
            }
        }
    }

    render() {
        if (!this.state.serverMarkup) return null;

        return (
            <div
                ref={(ref) => {
                    if (ref && !this.state.didRenderServerMarkup) {
                        this.setState({didRenderServerMarkup: true});
                    }
                }}
                dangerouslySetInnerHTML={{
                    __html: this.state.serverMarkup,
                }}
            />
        );
    }

    fetchNewMarkup = () => {
        this.setState({
            serverMarkup: null,
        });

        // Strip possible trailing slash
        const baseUrl = this.props.viewUrl.replace(/\/$/, '');
        const url = `${baseUrl}.webchunk${this.props.viewParams}`;

        viewApi
            // @ts-expect-error
            .get(url, undefined, headers)
            .then((res) => {
                // @ts-expect-error
                if (res.redirected) {
                    // @ts-expect-error
                    window.location = res.url;
                }

                return res;
            })
            // @ts-expect-error
            .then((res) => res.text())
            .then((body) => {
                this.setState({
                    serverMarkup: body,
                });
            });
    };
}

function setUpEvents() {
    $('.resync-email').on('click', function (e) {
        if ($(e.target).is('select')) {
            // select dropdown within the button, don't submit
            e.stopPropagation();

            return;
        }

        const that = $(this),
            replacement = $('<button class="button">Saving…</button>').css(
                'min-width',
                that.css('min-width')
            );
        that.after(replacement).hide();

        Nut.ajax.post({
            url: '/support/resync-email.json',
            data: {
                userEmailAddress: that.data('email-address'),
                days: that.find('select').val(),
            },
            success: function () {
                replacement.text('Saved');

                setTimeout(() => {
                    replacement.remove();
                    that.show();
                }, 3000);
            },
        });
    });

    $('.calendar-clear-tokens').on('click', function () {
        const that = $(this);

        Nut.ajax.post({
            url: '/support/clear-calendar-tokens.json',
            data: {
                username: $(this).data('username'),
                calendarId: $(this).data('calendar-id'),
            },
            success: function () {
                alert('Tokens cleared');
                that.hide();
            },
        });
    });

    $('.office365-calendar-clear-tokens').on('click', function () {
        const that = $(this);

        Nut.ajax.post({
            url: '/support/office365-clear-calendar-tokens.json',
            data: {
                userId: $(this).data('user-id'),
                calendarId: $(this).data('calendar-id'),
            },
            success: function () {
                alert('Tokens cleared');
                that.hide();
            },
        });
    });

    $('.smtp-global-disable-hostnames').on('click', function () {
        const that = $(this),
            buttonText = that.text().trim();
        that.text('Saving…');
        Nut.ajax.post({
            url: '/support/smtp-global-disable-hostnames.json',
            data: {
                hostnames: $('textarea#global-disable-verify').val(),
            },
            // @ts-expect-error
            success: function (data) {
                if (data.result) {
                    $('textarea#global-disable-verify').val(data.result.message || '');
                    that.text(buttonText);
                }
            },
        });
    });

    $('.convert-gmail-id').on('click', function () {
        Nut.ajax.post({
            url: '/support/convert-gmail-message-id.json',
            data: {
                sourceId: $('#gmailId').val(),
            },
            // @ts-expect-error
            success: function (data) {
                if (data.result && data.result.hex.length && data.result.dec.length) {
                    $('#gmailIdFormats').html(
                        `dec: ${data.result.dec} <br>hex: ${data.result.hex}`
                    );
                } else {
                    $('#gmailIdFormats').text('unknown');
                }
            },
        });
    });

    $('.office365-get-email').on('click', function () {
        Nut.ajax.post({
            url: '/support/office365-get-email.json',
            data: {
                externalId: $('#o365EmailId').val(),
                userId: $(this).data('user-id'),
            },
            // @ts-expect-error
            success: function (data) {
                if (data.email) {
                    $('#office365Message').html(JSON.stringify(data.email, null, 2));
                } else {
                    $('#office365Message').text('unknown');
                }
            },
        });
    });

    $('.smtp-resend-verification').on('click', function () {
        const that = $(this),
            buttonText = that.text().trim();
        that.text('Saving…');

        Nut.ajax.post({
            url: '/support/smtp-resend-verification.json',
            data: {
                userEmailAddress: $(this).data('email-address'),
            },
            // @ts-expect-error
            success: function (data) {
                if (data.result) {
                    $('#smtp-test-email-status').text(data.result.message || 'Unknown');
                }
                that.text(buttonText);
            },
        });
    });

    $('.activity-details button').on('click', function () {
        const activityId = $('.activity-details input').val();

        if (activityId) {
            // @ts-expect-error
            window.location = `/support/activity/${activityId}`;
        }
    });

    $('.test-notification').on('click', function (e) {
        const mobileId = $(e.target).data().id;

        if (mobileId) {
            Nut.ajax.post({
                url: '/setup/mobile/send-test-push-notification.json',
                data: {
                    id: mobileId,
                },
                success: function () {
                    alert('Push notification sent!');
                },
            });
        }
    });

    $('.toggle-setting').on('click', function (e) {
        const settingName = $(e.target).data().id;
        const settingValue = $(e.target).data().value;
        const userId = $(e.target).data().userId;

        if (settingName) {
            formEncodedApi
                .post('/support/update-user-setting.json', {
                    setting: settingName,
                    value: settingValue === 1 ? 0 : 1,
                    userId: userId || undefined,
                })
                .then(() => {
                    window.location.reload();
                })
                .catch(() => {
                    alert('Something went wrong… awkward!');
                });
        }
    });

    $('.tunable-setting-save').on('click', function (e) {
        const settingName = $(e.target).data().id;
        const settingValue = $(e.target).closest('tr').find('.tunable-setting-value').val();
        if (settingName) {
            formEncodedApi
                .post('/support/update-tunable.json', {
                    settingName: settingName,
                    settingValue: settingValue,
                })
                .then(() => {
                    location.reload();
                })
                .catch(() => {
                    alert('Something went wrong… awkward!');
                });
        }
    });

    $('.nutshell-advisor-override-toggle').on('click', function () {
        formEncodedApi
            .post('/support/toggle-nutshell-advisor-override.json', {})
            .then(() => {
                location.reload();
            })
            .catch(() => {
                alert('Something went wrong… awkward!');
            });
    });

    $('.sa-migrate').on('click', function (e) {
        const force = $(e.target).hasClass('force');

        Nut.ajax.post({
            url: '/support/sa-migrate.json',
            data: {
                force: force,
            },
            // @ts-expect-error
            success: function (data) {
                const result = data.result;

                $('.sa-migrate').hide();
                $('.sa-migration').find('.success').show();
                if (result.message) {
                    $('.sa-migration').find('.success').html(result.message);
                }
            },
            error: function () {
                $('.sa-migration').find('.error').show();
            },
        });
    });

    $('.email-address-add-error').on('click', function () {
        Nut.ajax.post({
            url: '/support/email-address-add-error.json',
            data: {
                userEmailAddress: $(this).data('email-address'),
                errorId: $(this).data('error-id'),
            },
        });
    });

    $('.email-address-clear-errors').on('click', function () {
        const that = $(this);

        Nut.ajax.post({
            url: '/support/email-address-clear-error.json',
            data: {
                userEmailAddress: $(this).data('email-address'),
            },
            success: function () {
                that.closest('.email_errors').hide();
            },
        });
    });

    $('.clear-integration').on('click', function () {
        Nut.ajax.post({
            url: '/support/clear-integration.json',
            data: {
                userId: $(this).data('user-id'),
                service: $(this).data('service'),
                clearAll: $(this).data('clear-all'),
            },
            success: function () {
                alert('Done. User will need to re-enable features and re-authenticate.');
            },
        });
    });

    $('.set-marketing-sending-enabled').on('click', function () {
        Nut.ajax.post({
            url: '/support/set-marketing-sending-enabled.json',
            data: {
                isDisabled: $(this).data('is-disabled'),
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.set-marketing-exceed-limit').on('click', function () {
        Nut.ajax.post({
            url: '/support/set-marketing-exceed-limit.json',
            data: {
                canExceed: $(this).data('can-exceed'),
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.set-marketing-email-limit-override').on('click', function () {
        const limit = $('input[name="limit"]').val();
        const daysUntilExpiry = $('input[name="daysUntilExpiry"]').val();

        if (!limit) {
            alert(
                'Set a monthly email limit before overriding, or if 0 is desired, click the button to disable sending instead.'
            );

            return;
        }

        Nut.ajax.post({
            url: '/support/set-emails-sent-this-month-limit-override.json',
            data: {
                limit: limit,
                daysUntilExpiry: daysUntilExpiry,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.remove-marketing-email-limit-override').on('click', function () {
        Nut.ajax.post({
            url: '/support/remove-emails-sent-this-month-limit-override.json',
            data: {},
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.set-marketable-contacts-override').on('click', function () {
        const num_contacts = $('input[name="num_contacts"]').val();
        Nut.ajax.post({
            url: '/support/set-marketable-contacts-override.json',
            data: {
                num_contacts: num_contacts,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.remove-marketable-contacts-override').on('click', function () {
        Nut.ajax.post({
            url: '/support/remove-marketable-contacts-override.json',
            data: {},
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.send-queued-email-now').on('click', function () {
        Nut.ajax.post({
            url: '/support/send-queued-email.json',
            data: {
                queuedEmailId: $(this).data('email-queued-id'),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.send-email-now').on('click', function () {
        Nut.ajax.post({
            url: '/support/send-email.json',
            data: {
                emailId: $(this).data('email-id'),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.delete-queued-email').on('click', function () {
        Nut.ajax.post({
            url: '/support/delete-queued-email.json',
            data: {
                queuedEmailId: $(this).data('email-queued-id'),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.delete-email').on('click', function () {
        Nut.ajax.post({
            url: '/support/delete-email.json',
            data: {
                emailId: $(this).data('email-id'),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.mailbox-delete-all').on('click', function () {
        Nut.ajax.post({
            url: '/support/delete-emails.json',
            data: {
                mailboxKey: $(this).data('mailbox-key'),
                userId: $(this).data('user-id'),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    alert(
                        'Job submitted! This could take a minute or two, but refreshing the page will eventually show an updated count!'
                    );
                }
            },
        });
    });

    $('.pmta-address-setup').on('click', function () {
        Nut.ajax.post({
            url: '/support/pmta-address-setup.json',
            data: {
                addressId: $('#address-id').val(),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    alert('DKIM keys and DNS records created');
                }
            },
        });
    });

    $('.support-bounce button.remove').on('click', function (e) {
        const bounceId = $(e.target).data().bounceId;

        Nut.loadingHudStart();
        $(e.target).prop('disabled', true).html('Unbouncing…');
        if (bounceId) {
            formEncodedApi
                .post('/support/marketing-bounce-remove.json', {
                    bounceId,
                })
                .then(() => {
                    Nut.loadingHudStop();
                    alert('bounce removed (we marked it as a temporary bounce).');
                })
                .catch(() => {
                    Nut.loadingHudStop();
                    alert('Something went wrong… awkward!');
                });
        }
    });

    $('.review-pages .approve').on('click', function (e) {
        const apiId = $(e.target).data().apiId;

        Nut.loadingHudStart();
        $(e.target).prop('disabled', true).html('Approving…');
        if (apiId) {
            formEncodedApi
                .post('/support/review-approve.json', {
                    apiId,
                })
                .then(() => {
                    // @ts-expect-error
                    window.location = '/support/review';
                })
                .catch(() => {
                    Nut.loadingHudStop();
                    alert('Something went wrong… awkward!');
                });
        }
    });

    $('.regenerate-mfa').on('click', function (e) {
        const userId = $(e.target).data().userId;
        const mfaType = $(e.target).data().mfaType;
        Nut.ajax.post({
            url: '/support/regenerate-mfa.json',
            data: {
                userId: userId,
                mfaType: mfaType,
                userData: $('#user-data').val(),
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.verify-mfa-code').on('click', function (e) {
        const userId = $(e.target).data().userId;
        const mfaType = $(e.target).data().mfaType;
        Nut.ajax.post({
            url: '/support/verify-mfa-code.json',
            data: {
                userId: userId,
                mfaCode: $('#mfa-code-verify').val(),
                mfaType: mfaType,
            },
            // @ts-expect-error
            success: function (res) {
                if (res.result) {
                    window.location.reload();
                } else {
                    alert('Invalid code');
                }
            },
        });
    });

    $('.send-mfa-code').on('click', function (e) {
        const userId = $(e.target).data().userId;
        Nut.ajax.post({
            url: '/support/send-phone-mfa-code.json',
            data: {
                userId: userId,
            },
            success: function () {
                alert('Code sent');
            },
        });
    });

    $('.test-mfa-code').on('click', function (e) {
        const userId = $(e.target).data().userId;
        Nut.ajax.post({
            url: '/support/test-mfa-code.json',
            data: {
                userId: userId,
                mfaCode: $('#mfa-code-test').val(),
            },
            // @ts-expect-error
            success: function (res) {
                alert(res.result ? 'Good code' : 'Bad code');
            },
        });
    });

    $('.test-backup-mfa-code').on('click', function (e) {
        const userId = $(e.target).data().userId;
        Nut.ajax.post({
            url: '/support/test-backup-mfa-code.json',
            data: {
                userId: userId,
                mfaCode: $('#mfa-backup-code-test').val(),
            },
            // @ts-expect-error
            success: function (res) {
                alert(res.result ? 'Good code' : 'Bad code');
                if (res.result) {
                    window.location.reload();
                }
                $('#mfa-backup-code-test').val('');
            },
        });
    });

    $('.generate-mfa-backup-code').on('click', function (e) {
        const userId = $(e.target).data().userId;
        Nut.ajax.post({
            url: '/support/regenerate-backup-codes.json',
            data: {
                userId: userId,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.unpause-automated-emails').on('click', function (e) {
        const userId = $(e.target).data().userId;
        Nut.ajax.post({
            url: '/support/unpause-automated-emails.json',
            data: {
                userId: userId,
            },
            success: function () {
                alert('Emails are being unpaused');
            },
        });
    });

    $('.save-pending-support-coupon').on('click', function () {
        const couponCode = $(this).siblings('.coupon-code-value').val();
        if (couponCode) {
            Nut.ajax.post({
                url: '/support/save-pending-support-coupon.json',
                data: {
                    couponCode: couponCode,
                },
                // @ts-expect-error
                success: function (res) {
                    if (res.error) {
                        alert(res.error);
                    } else {
                        window.location.reload();
                    }
                },
            });
        }
    });

    $('.remove-pending-support-coupon').on('click', function (e) {
        const couponCode = $(e.target).data().couponCode;
        if (couponCode) {
            Nut.ajax.post({
                url: '/support/remove-pending-support-coupon.json',
                data: {
                    couponCode: couponCode,
                },
                // @ts-expect-error
                success: function (res) {
                    if (res.error) {
                        alert(res.error);
                    } else {
                        window.location.reload();
                    }
                },
            });
        }
    });

    $('.toggle-conditional-coupon').on('click', function (e) {
        const couponCode = $(e.target).data().couponCode;
        const isEnabled = $(e.target).data().isEnabled;

        if (couponCode) {
            Nut.ajax.post({
                url: '/support/toggle-conditional-coupon.json',
                data: {
                    couponCode: couponCode,
                    isEnabled: isEnabled,
                },
                // @ts-expect-error
                success: function (res) {
                    if (res.error) {
                        alert(res.error);
                    } else {
                        window.location.reload();
                    }
                },
            });
        }
    });

    $('.handle-external-activity').on('click', function () {
        const removing = $(this).data('is-remove');
        Nut.ajax.post({
            url: '/support/handle-external-activity.json',
            data: {
                externalId: $('#externalId').val(),
                doClear: removing,
            },
            // @ts-expect-error
            success: function (data) {
                if (data.result) {
                    window.location.reload();
                } else {
                    $('#handleActivityResponse').text('Error in handling external activity');
                }
            },
        });
    });

    $('.get-email-counts').on('click', function () {
        const address = $('#address').val();

        Nut.ajax.post({
            url: '/support/get-email-counts.json',
            data: {
                address: address,
            },
            // @ts-expect-error
            success: function (data) {
                if (data.counts) {
                    $('#activeEmailCount').text(data.counts.active);
                    $('#deletedEmailCount').text(data.counts.deleted);
                    $('#privateEmailCount').text(data.counts.private);
                    $('#numContacts').text(data.counts.contacts);
                    $('#numAccounts').text(data.counts.accounts);
                    $('.remove-emails').data('count', data.counts.active);
                } else {
                    $('#handleEmailResponse').text('Error in checking email');
                }
            },
        });
    });

    $('.remove-emails').on('click', function () {
        const address = $('#address').val();
        const count = String($('.remove-emails').data('count'));

        const amountCopy = count !== '' ? count : 'all related';

        if (confirm(`This will delete ${amountCopy} email(s). Are you sure?`)) {
            Nut.ajax.post({
                url: '/support/remove-emails.json',
                data: {
                    address: address,
                },
                // @ts-expect-error
                success: function (data) {
                    if (data.deleteCount !== null) {
                        if (data.deleteCount === 0) {
                            $('#handleEmailResponse').text('No emails to remove');
                        } else {
                            const plural = data.deleteCount > 1 ? 's' : '';
                            $('#handleEmailResponse').text(
                                `Removed ${data.deleteCount} email${plural}!`
                            );

                            Nut.ajax.post({
                                url: '/support/get-email-counts.json',
                                data: {
                                    address: address,
                                },
                                // @ts-expect-error
                                success: function (refreshData) {
                                    if (refreshData.counts) {
                                        $('#activeEmailCount').text(refreshData.counts.active);
                                        $('#deletedEmailCount').text(refreshData.counts.deleted);
                                        $('#privateEmailCount').text(refreshData.counts.private);
                                        $('#numContacts').text(refreshData.counts.contacts);
                                        $('#numAccounts').text(refreshData.counts.accounts);
                                    } else {
                                        $('#handleEmailResponse').text('Error in checking email');
                                    }
                                },
                            });
                        }
                    } else {
                        $('#handleEmailResponse').text('Error in removing emails');
                    }
                },
            });
        }
    });

    $('.set-legacy-forms-spam').on('click', function () {
        const choice = $(this).data('choice');
        Nut.ajax.post({
            url: '/support/spam-protection-set-all.json',
            data: {
                choice: choice,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.print-webhook').on('click', function () {
        const type = $(this).data('type');
        const id = $('#changeLogId').val();
        Nut.ajax.post({
            url: '/support/print-webhook.json',
            data: {
                id: id,
                type: type,
            },
            // @ts-expect-error
            success: function (res) {
                if (res.result) {
                    $('#webhookField').text(res.result);
                }
            },
        });
    });

    $('#nutshell-channel-config').on('click', '.change-channel', function () {
        const saveButton = $(this),
            replacement = $('<button class="button">Saving…</button>');

        saveButton.after(replacement).hide();

        const channelId = $(this).data('channelId'),
            twilioNumber = $('#twilioNumber').val();

        Nut.ajax.post({
            url: '/support/change-twilio-number.json',
            data: {
                channelId,
                twilioNumber,
            },
            // @ts-expect-error
            success: function (response) {
                if (response.html) {
                    $('#nutshell-channel-config').html(response.html);
                } else {
                    $('#handleNumberResponse').text('Error in changing the channel').show();
                    setTimeout(() => {
                        $('#handleNumberResponse').fadeOut('slow');
                    }, 3000);
                }
            },
        });
    });

    $('#nutshell-channel-config').on('click', '.save-channel', function () {
        const saveButton = $(this),
            replacement = $('<button class="button">Saving…</button>');

        saveButton.after(replacement).hide();

        const channelId = $(this).data('channelId'),
            twilioNumberSid = $(this).data('twilioNumberSid'),
            phoneNumber = $('#phoneNumber').val(),
            webhook = $('#webhook').val(),
            numberCountryCode = $('#number-country-code').val();

        Nut.ajax.post({
            url: '/support/update-nutshell-channel.json',
            data: {
                channelId,
                twilioNumberSid,
                phoneNumber,
                webhook,
                numberCountryCode,
            },
            // @ts-expect-error
            success: function (response) {
                if (response.html) {
                    $('#nutshell-channel-config').html(response.html);
                } else {
                    $('#handleNumberResponse').text('Some sort of error happened').show();
                    setTimeout(() => {
                        $('#handleNumberResponse').fadeOut('slow');
                    }, 3000);
                }
            },
        });
    });

    $('.save-twilio-integration').on('click', function () {
        const saveButton = $(this),
            replacement = $('<button class="button">Saving…</button>');

        saveButton.after(replacement).hide();

        const data = $('#twilio-integration-values input')
            .toArray()
            .reduce<Record<string, any>>((acc, cur) => {
                // @ts-expect-error
                acc[$(cur).attr('name')] = $(cur).val();

                return acc;
            }, {});

        Nut.ajax.post({
            url: '/support/save-twilio-integration.json',
            data: {data},
            // @ts-expect-error
            success: function (response) {
                replacement.text('Saved!');
                $('#twilio-integration-values').html(response.html || '');

                if (response.htmlChannel) {
                    $('#nutshell-channel-config').html(response.htmlChannel);
                }
                setTimeout(() => {
                    replacement.remove();
                    saveButton.text('Save');
                    saveButton.show();
                    $('.delete-twilio-integration').show();
                }, 2000);
            },
        });
    });

    $('.delete-twilio-integration').on('click', function () {
        const deleteButton = $(this);

        if (confirm(`Are you sure?`)) {
            Nut.ajax.post({
                url: '/support/delete-twilio-integration.json',
                // @ts-expect-error
                success: function (response) {
                    $('#twilio-integration-values').html(response.html || '');
                    if (response.htmlChannel) {
                        $('#nutshell-channel-config').html(response.htmlChannel);
                    }

                    deleteButton.hide();
                    $('.save-twilio-integration').text('Create');
                },
            });
        }
    });

    $('.prompt-twilio-check').on('click', function () {
        Nut.ajax.post({
            url: '/support/prompt-twilio-check.json',
            // @ts-expect-error
            success: function (response) {
                if (response.result) {
                    window.location.reload();
                }
            },
        });
    });

    $('.toggle-messaging').on('click', function () {
        const isPaused = $(this).data('paused');

        Nut.ajax.post({
            url: '/support/toggle-messaging.json',
            data: {
                isPaused: isPaused,
            },
            // @ts-expect-error
            success: function (response) {
                if (response.result) {
                    window.location.reload();
                }
            },
        });
    });

    $('.set-inbox-credit-limit-override').on('click', function () {
        const limit = $('input[name="limit"]').val();
        const daysUntilExpiry = $('input[name="daysUntilExpiry"]').val();

        if (!limit) {
            alert('Set a monthly credit limit before overriding.');

            return;
        }

        Nut.ajax.post({
            url: '/support/set-sms-credit-limit-override.json',
            data: {
                limit: limit,
                daysUntilExpiry: daysUntilExpiry,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.set-inbox-credit-limit-month-override').on('click', function () {
        const limit = $('input[name="limit-month"]').val();
        const daysUntilExpiry = $('input[name="daysUntilEndOfMonth"]').val();

        if (!limit) {
            alert('Set a monthly credit limit before overriding.');

            return;
        }

        Nut.ajax.post({
            url: '/support/set-sms-credit-limit-override.json',
            data: {
                limit: limit,
                daysUntilExpiry: daysUntilExpiry,
            },
            success: function () {
                window.location.reload();
            },
            error: function () {
                alert('Error setting monthly credit limit override.');
            },
        });
    });

    $('.remove-inbox-credit-limit-override').on('click', function () {
        Nut.ajax.post({
            url: '/support/remove-sms-credit-limit-override.json',
            data: {},
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.set-nutshell-iq-credit-limit-override').on('click', function () {
        const limit = $('input[name="limit"]').val();
        const daysUntilExpiry = $('input[name="daysUntilExpiry"]').val();

        if (!limit) {
            alert('Set a monthly unlock limit before overriding.');

            return;
        }

        Nut.ajax.post({
            url: '/support/set-nutshell-iq-credit-limit-override.json',
            data: {
                limit: limit,
                daysUntilExpiry: daysUntilExpiry,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.set-nutshell-iq-credit-limit-month-override').on('click', function () {
        const limit = $('input[name="limit-month"]').val();
        const daysUntilExpiry = $('input[name="daysUntilEndOfMonth"]').val();

        if (!limit) {
            alert('Set a monthly unlock limit before overriding.');

            return;
        }

        Nut.ajax.post({
            url: '/support/set-nutshell-iq-credit-limit-override.json',
            data: {
                limit: limit,
                daysUntilExpiry: daysUntilExpiry,
            },
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.remove-nutshell-iq-credit-limit-override').on('click', function () {
        Nut.ajax.post({
            url: '/support/remove-nutshell-iq-credit-limit-override.json',
            data: {},
            success: function () {
                window.location.reload();
            },
        });
    });

    $('.print-integration-data').on('click', function () {
        const integrationId = $('#integrationId').val();
        Nut.ajax.post({
            url: '/support/print-integration-details.json',
            data: {
                integrationId: integrationId,
            },
            // @ts-expect-error
            success: function (res) {
                if (res.username && res.credentials) {
                    $('#integrationUsernameField').text(res.username);
                    $('#integrationCredentialsField').text(res.credentials);
                }
            },
        });
    });

    $('.save-dev-plan').on('click', function () {
        const settings: Record<string, any> = {};
        // CRM
        settings.override_crm_plan = $(this).siblings('.crm-plan-value').val();
        settings.override_crm_seats = $(this).siblings('.crm-seats-value').val();
        if (settings.override_crm_seats <= 0) {
            alert('Please enter a valid number of CRM seats');

            return;
        }

        // Email Campaigns
        settings.override_marketing_plan = $(this).siblings('.marketing-plan-value').val();

        // Marketing Suite
        settings.override_marketing_suite_plan = $(this)
            .siblings('.marketing-suite-plan-value')
            .val();
        settings.override_sms_campaigns_plan = $(this).siblings('.sms-campaigns-plan-value').val();

        // Engagement
        settings.override_engagement_plan = $(this).siblings('.engagement-plan-value').val();
        settings.override_engagement_seats = $(this).siblings('.engagement-seats-value').val();
        if (
            settings.override_engagement_plan === 'ne-uub-m' &&
            settings.override_engagement_seats <= 0
        ) {
            alert('Number of engagement seats must be greater than 0 with plan enabled');

            return;
        }
        if (settings.override_engagement_plan === 'foundation') {
            settings.override_engagement_seats = settings.override_crm_seats;
        }

        // Add-ons
        settings.override_revenue_booster = $(this).siblings('.revenue-booster-plan-value').val();
        settings.override_landing_pages = $(this).siblings('.landing-pages-plan-value').val();
        settings.override_nutshell_iq = $(this).siblings('.nutshell-iq-plan-value').val();

        if (settings) {
            Nut.ajax.post({
                url: '/support/save-dev-override.json',
                data: {
                    settings: settings,
                },
                // @ts-expect-error
                success: function (res) {
                    if (res.error) {
                        alert(res.error);
                    } else {
                        window.location.reload();
                    }
                },
            });
        }
    });

    $('.clear-development-overrides').on('click', function () {
        Nut.ajax.post({
            url: '/support/clear-development-overrides.json',
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.inbox-chat-config-delete').on('click', () => {
        if (confirm(`Are you sure?`)) {
            Nut.ajax.post({
                url: '/support/inbox-chat-config-delete.json',
                // @ts-expect-error
                success: (response) => {
                    if (response.error) {
                        alert(response.error);
                    } else {
                        window.location.reload();
                    }
                },
            });
        }
    });

    $('.reset-scheduler-availability').on('click', function () {
        Nut.ajax.post({
            url: '/support/reset-scheduler-availability.json',
            data: {
                userId: $(this).data('user-id'),
            },
            // @ts-expect-error
            success: function (response) {
                if (response.error) {
                    alert(response.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.toggle-instance-setting').on('click', function (e) {
        const settingName = $(e.target).data().id;
        const settingValue = $(e.target).data().value;

        if (settingName) {
            formEncodedApi
                .post('/support/update-instance-setting.json', {
                    setting: settingName,
                    value: settingValue === 1 ? 0 : 1,
                })
                .then(() => {
                    window.location.reload();
                })
                .catch(() => {
                    alert('Something went wrong… awkward!');
                });
        }
    });

    $('.queue-directory-sync').on('click', function () {
        formEncodedApi
            // @ts-expect-error
            .post('/support/queue-directory-sync.json')
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                alert('Something went wrong… awkward!');
            });
    });

    $('.toggle-call-tracker').on('click', function () {
        const isEnabled = $(this).data('enabled');
        Nut.ajax.post({
            url: '/support/toggle-call-tracker.json',
            data: {isEnabled},
            // @ts-expect-error
            success: function (response) {
                if (response.error) {
                    alert(response.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.delete-context-document').on('click', function () {
        Nut.ajax.post({
            url: '/support/delete-context-document.json',
            data: {
                documentId: $(this).data('document-id'),
            },
            // @ts-expect-error
            success: function (res) {
                if (res.error) {
                    alert(res.error);
                } else {
                    window.location.reload();
                }
            },
        });
    });

    $('.generate-nscid').on('click', function () {
        const email = $('#nscidEmail').val();
        if (!email) {
            alert('Please enter an email address');

            return;
        }

        Nut.ajax.post({
            url: '/support/generate-nscid.json',
            data: {
                email: email,
            },
            // @ts-expect-error
            success: function (res) {
                if (res.success) {
                    $('#nscidParamName').text(res.paramName);
                    $('#nscidValue').text(res.nscid);
                    $('#nscidFullParam').text(res.fullParam);
                    $('#nscidExampleUrl').text(`https://example.com/page?${res.fullParam}`);
                    $('#nscidResult').show();
                } else {
                    alert(`Error: ${res.error}`);
                }
            },
        });
    });

    // Prefill the datetime picker with the current value if set
    const currentIso = $('#delayAllSolrExpires').data('current-iso');
    if (currentIso) {
        const currentDate = new Date(currentIso);
        // Format as datetime-local value (YYYY-MM-DDTHH:MM) in local time
        const pad = (n: number) => String(n).padStart(2, '0');
        const localValue =
            currentDate.getFullYear() +
            '-' +
            pad(currentDate.getMonth() + 1) +
            '-' +
            pad(currentDate.getDate()) +
            'T' +
            pad(currentDate.getHours()) +
            ':' +
            pad(currentDate.getMinutes());
        $('#delayAllSolrExpires').val(localValue);
    }

    $('.set-delay-all-solr').on('click', function () {
        const datetimeLocal = $('#delayAllSolrExpires').val() as string;
        if (!datetimeLocal) {
            alert('Please select an expiration date and time');

            return;
        }

        // Convert local datetime to ISO 8601 with the user's UTC offset
        const date = new Date(datetimeLocal);
        const offsetMinutes = date.getTimezoneOffset();
        const sign = offsetMinutes <= 0 ? '+' : '-';
        const absOffset = Math.abs(offsetMinutes);
        const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, '0');
        const offsetMins = String(absOffset % 60).padStart(2, '0');
        const expiresIso = datetimeLocal + ':00' + sign + offsetHours + ':' + offsetMins;

        const includingRealtime = $('#delayAllSolrRealtime').is(':checked');

        Nut.ajax.post({
            url: '/support/set-delay-all-solr.json',
            data: {
                expires: expiresIso,
                includingRealtime: includingRealtime ? 1 : 0,
            },
            // @ts-expect-error
            success: function (res) {
                if (res.success) {
                    window.location.reload();
                } else {
                    alert('Failed to set delay');
                }
            },
        });
    });

    $('.remove-delay-all-solr').on('click', function () {
        Nut.ajax.post({
            url: '/support/set-delay-all-solr.json',
            data: {},
            // @ts-expect-error
            success: function (res) {
                if (res.success) {
                    window.location.reload();
                } else {
                    alert('Failed to remove delay');
                }
            },
        });
    });

    $('.copy-nscid').on('click', function () {
        const fullParam = $('#nscidFullParam').text();
        navigator.clipboard.writeText(fullParam).then(function () {
            alert('Copied to clipboard!');
        });
    });

    $('.force-complete-edition').on('click', function () {
        if (
            !window.confirm(
                'This will mark all remaining emails as failed and close the edition. Are you sure?'
            )
        ) {
            return;
        }
        const btn = $(this);
        btn.prop('disabled', true);
        Nut.ajax.post({
            url: '/support/marketing-force-complete-edition.json',
            data: {editionApiId: btn.data('api-id')},
            success: function () {
                window.location.reload();
            },
            error: function () {
                alert('Something went wrong. The edition could not be found.');
                btn.prop('disabled', false);
            },
        });
    });

    $('.requeue-unsent-emails').on('click', function () {
        if (!window.confirm('This will re-queue unsent emails for delivery. Are you sure?')) {
            return;
        }
        const btn = $(this);
        const originalText = btn.text();
        btn.prop('disabled', true).text('Re-queuing…');
        Nut.ajax.post({
            url: '/support/marketing-requeue-unsent-emails.json',
            data: {editionApiId: btn.data('api-id')},
            success: function (response: string) {
                let notice = 'requeued';
                try {
                    const data = JSON.parse(response);
                    if (data.unsentCount !== undefined) {
                        notice = `requeued:${data.unsentCount}`;
                    }
                } catch (_e) {
                    // fall back to generic notice
                }
                window.location.href =
                    window.location.pathname + '?notice=' + encodeURIComponent(notice);
            },
            error: function () {
                alert('Something went wrong. The edition could not be found.');
                btn.prop('disabled', false).text(originalText);
            },
        });
    });

    if (window.location.search.includes('notice=')) {
        window.history.replaceState(null, '', window.location.pathname);
    }
}
